var _rect, _rect2, _rect3, _g, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesTwoUpholsteredArc1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M13.2,177.1c0,0-0.5,0.2-0.6,0.8 s-0.1,2.8-0.1,2.8s-0.1,0.7,0.7,0.9c0.8,0.3,4.8,1.2,6,1.5c1.3,0.3,9.4,2.5,11.6,2.8c2.2,0.4,11.6,2.1,13.6,2.4 c1.9,0.3,16.3,1.8,19.1,1.9s6.3-0.1,8.2,0c1.9,0.1,8.2-0.9,12.4-1.3c2.1-0.2,7.5-1.1,8.6-1.4c1-0.2,14.9-3.9,15.6-4.1 c0.7-0.2,6.1-1.8,6.5-2s0.6-0.2,0.7-1s0.1-2.2,0.1-2.2s0.1-0.4-0.1-0.5c-0.2-0.1-0.6-0.3-0.6-0.3l-10.5,2.8l-13.6,2.5l-10.4,2.4 l-14.1,0.7L45,183.5l-20.5-3.9l-10.9-2.9L13.2,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M13.5,172.5c0,0-0.8,0.4-0.8,1 c0,0.6,0,2.7,0,2.7s-0.3,0.5,0.5,0.8c0.7,0.2,4.9,1.6,6,1.9c1.1,0.2,12.5,2.8,15,3.3c2.5,0.6,17.3,2.9,21,3.2s14.7,1.1,14.7,1.1 s10.1-0.7,12.6-1s11.7-2.5,14-2.9c2.2-0.4,14.8-3.4,16.6-3.9c1.8-0.5,2.3-0.8,2.3-0.8s0.6,0,0.6-1.3c0-1.3,0-2.3,0-2.3 s-0.1-0.8-0.8-0.9s-0.6-0.3-0.6-0.3l-6.7,1.8l-19.7,4.9L74,181.7l-7.3-0.2l-9.7-0.3l-12.3-1.7l-16.8-3.3l-11.9-3.6l-2.1-0.6 L13.5,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M13.4,167.3c0,0-0.9,0.4-0.9,1.6 c0,1.2,0,2,0,2s-0.2,0.9,0.9,1.3c1.1,0.5,7.2,2.5,8.7,2.9c1.5,0.4,18.1,4.5,22,5c3.9,0.5,19.1,2.2,27.1,2 c8.1-0.2,17.8-2.2,19.3-2.3s9.6-2.4,10.9-2.7s12.9-3.8,13.7-4.1c0.8-0.3,0.8-0.4,0.8-1.6c0-1.2,0.1-2.1-0.4-2.8 c-0.5-0.7-0.9-0.8-0.9-0.8l-0.6-0.5l-22,5.5l-11.7,2.2l-12.7,0.7l-11.1-1l-15.3-2.4L14,166.8L13.4,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M13.1,10.6h101.5v141.8 c0,0,1.3,5.2,1.3,8.1c0,2.9,0,5,0,5s0.4,1.6-2,2.2s-9.4,2.8-14.9,4c-8,1.7-18,3.7-21.4,3.9s-9.2,0.7-16.5,0 c-7.3-0.7-27.9-4-31.8-4.8c-3.9-0.8-14.7-3.5-15.7-3.9s-1.8-0.7-1.4-4s1-7.1,1-8.8C13.2,152.3,13.1,10.6,13.1,10.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M117.6,211.3c0,0-0.5,0.2-0.6,0.8 s-0.1,2.8-0.1,2.8s-0.1,0.7,0.7,0.9c0.8,0.3,4.8,1.2,6,1.5s9.4,2.5,11.6,2.8c2.2,0.4,11.6,2.1,13.6,2.4c1.9,0.3,16.3,1.8,19.1,1.9 s6.3-0.1,8.2,0c1.9,0.1,8.2-0.9,12.4-1.3c2.1-0.2,7.5-1.1,8.6-1.4c1-0.2,14.9-3.9,15.6-4.1c0.7-0.2,6.1-1.8,6.5-2 c0.4-0.1,0.6-0.2,0.7-1c0.1-0.8,0.1-2.2,0.1-2.2s0.1-0.4-0.1-0.5s-0.6-0.3-0.6-0.3l-10.5,2.8l-13.6,2.5l-10.4,2.4l-14.1,0.7 l-21.3-2.4l-20.5-3.9l-10.9-2.9L117.6,211.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M117.8,206.6c0,0-0.8,0.4-0.8,1 c0,0.6,0,2.7,0,2.7s-0.3,0.5,0.5,0.8c0.7,0.2,4.9,1.6,6,1.9c1.1,0.2,12.5,2.8,15,3.3c2.5,0.6,17.3,2.9,21,3.2s14.7,1.1,14.7,1.1 s10.1-0.7,12.6-1s11.7-2.5,14-2.9c2.2-0.4,14.8-3.4,16.6-3.9c1.8-0.5,2.3-0.8,2.3-0.8s0.6,0,0.6-1.3c0-1.3,0-2.3,0-2.3 s-0.1-0.8-0.8-0.9c-0.6,0-0.6-0.3-0.6-0.3l-6.7,1.8l-19.7,4.9l-14.2,2.1l-7.3-0.2l-9.7-0.3l-12.3-1.7l-16.8-3.3l-11.9-3.6 l-2.1-0.6L117.8,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M117.8,201.5c0,0-0.9,0.4-0.9,1.6 c0,1.2,0,2,0,2s-0.2,0.9,0.9,1.3c1.1,0.5,7.2,2.5,8.7,2.9s18.1,4.5,22,5c3.9,0.5,19.1,2.2,27.1,2s17.8-2.2,19.3-2.3 s9.6-2.4,10.9-2.7s12.9-3.8,13.7-4.1c0.8-0.3,0.8-0.4,0.8-1.6c0-1.2,0.1-2.1-0.4-2.8S219,202,219,202l-0.6-0.5l-22,5.5l-11.7,2.2 l-12.7,0.7l-11.1-1l-15.3-2.4l-27.2-5.4L117.8,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.2541,
    strokeMiterlimit: 10,
    d: "M117.5,10.6h101.5v175.9 c0,0,1.3,5.2,1.3,8.1c0,2.9,0,5,0,5s0.4,1.6-2,2.2s-9.4,2.8-14.9,4c-8,1.7-18,3.7-21.4,3.9c-3.4,0.2-9.2,0.7-16.5,0 c-7.3-0.7-27.9-4-31.8-4.8c-3.9-0.8-14.7-3.5-15.7-3.9c-1.1-0.3-1.8-0.7-1.4-4c0.4-3.3,1-7.1,1-8.8 C117.5,186.5,117.5,10.6,117.5,10.6z"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 2,
    fill: "#E3E3E2",
    stroke: "#B2B2B2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 215.4,
    height: 19.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwoUpholsteredArc1);
export default __webpack_public_path__ + "static/media/FeaturesTwoUpholstered_arc1.e68e3ad4b0edec29208088c93652b715.svg";
export { ForwardRef as ReactComponent };